import { Component, OnInit } from '@angular/core';
import { TableDataSource } from '../../../utils/table-data-source';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DialogsService } from '../../../services/dialogs-service';
import { MdSnackBar } from '@angular/material';
import { PreciosService} from '../../../services/precios-service';

@Component({
  selector: 'app-mercado',
  templateUrl: './mercado.component.html',
  styleUrls: ['./mercado.component.scss']
})
export class MercadoComponent implements OnInit {

  mercadosSubject$ = new BehaviorSubject<any[]>([]);
  mercadosDataSource = new TableDataSource(this.mercadosSubject$);
  marcadosDisplayedColumns = ['nombre', 'codigo', 'accion'];
  mercadosResponseData = [];

//   public Int16 Id { get; set; }
//
// public string Mercado { get; set; }
//
// public bool Visibilidad { get; set; }
//
// public string Codigo { get; set; }

  constructor(private preciosService: PreciosService,
              private dialogsService: DialogsService,
              private snackBar: MdSnackBar) {
    this.loadData();
  }

  ngOnInit() {
  }

  loadData() {
    this.preciosService.getMercadosPizarra(true).subscribe(x => {
      if (x) {
        console.log(x);
        this.mercadosResponseData = x;
        this.mercadosSubject$.next(this.mercadosResponseData);
      }
    });
  }

  showNewMercadoDialog() {
    this.dialogsService.showNewEditMercadoDialog(this.mercadosResponseData.map(x => x.Codigo)).subscribe(res => {
      if (res) {
        this.loadData();
      }
    });
  }

  showEditMercadoDialog(mercado: Mercado) {
    this.dialogsService.showNewEditMercadoDialog(this.mercadosResponseData.map(x => x.Codigo), mercado).subscribe(res => {
      if (res) {
        this.loadData();
      }
    });
  }

  toggleMercadoVisibility(mercado: Mercado) {
    const str = mercado.Visibilidad ? 'ocultar' : 'mostrar';
    this.dialogsService.confirm(`¿Está seguro que desea ${str} este Mercado?`, null, `Sí, ${str.charAt(0).toUpperCase() + str.slice(1)}`, 'No, Cancelar').subscribe(res => {
      this.preciosService.toggleMercadoVisibilidad(mercado.Id).subscribe(x => {
        if (x) {
          this.loadData();
        }
      }, err => {
        this.snackBar.open('Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.', '', {
          duration: 2000,
          extraClasses: ['agd-warning-snackbar']
        });
      });
    });
  }

}

interface Mercado {
  Id: number;
  Mercado: string;
  Visibilidad: boolean;
  Codigo: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/mercado/mercado.component.ts